import { createReducer } from "@reduxjs/toolkit";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import type { RequestState } from "@redux/state/shared-types";
import { initializeContract, resetInitializeContract } from "./enable-subcontracting-contract";

export interface ContractInitializationState {
  processing: RequestState;
  signatureLink: Nullable<string>;
}

const initialState: ContractInitializationState = { processing: "idle", signatureLink: null };

export const enableSubcontractingContractReducer = createReducer<ContractInitializationState>(initialState, builder => {
  builder
    .addCase(initializeContract.fulfilled, (state, action) => {
      return {
        ...state,
        processing: "success",
        signatureLink: action.payload,
      };
    })
    .addCase(initializeContract.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(initializeContract.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetInitializeContract, () => {
    return initialState;
  });
});
